var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/uniqNodeRef.ts";
import { uniqWith } from 'ramda';
import { baseTypesMap } from "./BaseTypesMap";
export var uniqNodeRef = uniqWith(function (left, right) {
  var leftType = baseTypesMap[left.type];
  var rightType = baseTypesMap[right.type];
  return leftType === rightType && left.id === right.id;
});